const ArrivalBranchIcon = ({
  color,
  height = 32, 
  width = 32,
  uniqueId,
  radiosColor1,
  radiosColor2,
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle r="16" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 16 16)" fill={`url(#${uniqueId})`} />
      <circle r="14" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 16 16)" fill="white"/>
      <path d="M21.3335 10H16.0002C15.6335 10 15.3335 10.3 15.3335 10.6667V11.74C15.3335 11.74 15.3335 11.74 15.3402 11.7467L18.6735 14.7467C19.0935 15.12 19.3335 15.6667 19.3335 16.2333V16.6667H20.6668V18H19.3335V19.3333H20.6668V20.6667H19.3335V22H21.3335C21.7002 22 22.0002 21.7 22.0002 21.3333V10.6667C22.0002 10.3 21.7002 10 21.3335 10ZM18.0002 12.6667H16.6668V11.3333H18.0002V12.6667ZM20.6668 15.3333H19.3335V14H20.6668V15.3333ZM20.6668 12.6667H19.3335V11.3333H20.6668V12.6667Z" fill={color}/>
      <path d="M18 21.3331V16.2331C18 16.0464 17.92 15.8664 17.78 15.7397L14.4467 12.7397C14.32 12.6197 14.16 12.5664 14 12.5664C13.84 12.5664 13.68 12.6264 13.5533 12.7397L10.22 15.7397C10.08 15.8597 10 16.0397 10 16.2331V21.3331C10 21.6997 10.3 21.9997 10.6667 21.9997H12C12.3667 21.9997 12.6667 21.6997 12.6667 21.3331V18.6664H15.3333V21.3331C15.3333 21.6997 15.6333 21.9997 16 21.9997H17.3333C17.7 21.9997 18 21.6997 18 21.3331Z" fill={color}/>
      <defs>
        <linearGradient id={uniqueId} x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor={radiosColor1} />
          <stop offset="0.885417" stopColor={radiosColor2} />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default ArrivalBranchIcon;
